// extracted by mini-css-extract-plugin
export default {"container":"filter_dropdown_box-module__container--P61ac"};